import { render, staticRenderFns } from "./KioskView.vue?vue&type=template&id=1312c968"
import script from "./KioskView.vue?vue&type=script&lang=ts"
export * from "./KioskView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports